<div class="container">
  <div class="search-container">
    <form [formGroup]="orderCheckoutForm" (submit)="submitTrackStatus()">
      <div class="container">
        <div class="row">
          <div class="vs-text-field col-lg-3 col-md-6 col-sm-12 space-right-cn">
            <label class="search-field-label">{{
              'guesttrack.customerno' | cxTranslate
            }}</label>
            <input
              type="text"
              class="txt-field-length"
              (keypress)="numberOnly($event)"
              formControlName="customerNumber"
              [ngClass]="firstMandateFieldError ? 'error-select' : ''"
              maxlength="10"
            />
          </div>
          <div
            class="vs-text-field col-lg-3 col-md-6 col-sm-12 space-right-pon"
          >
            <label class="search-field-label">{{
              'guesttrack.purchaseorder' | cxTranslate
            }}</label>
            <input
              type="text"
              class="txt-field-length"
              formControlName="purchaseOrderNo"
              [ngClass]="secondMandateFieldError ? 'error-select' : ''"
              maxlength="35"
            />
          </div>
          <div class="or-divide space-right-or">
            {{ 'guesttrack.or' | cxTranslate }}
          </div>
          <div class="vs-text-field col-lg-3 col-md-6 col-sm-12 space-right-qr">
            <label class="search-field-label"
              >{{ 'guesttrack.orderrefer' | cxTranslate }}
            </label>
            <input
              type="text"
              class="txt-field-length"
              (keypress)="numberOnly($event)"
              formControlName="referenceNumber"
              [ngClass]="secondMandateFieldError ? 'error-select' : ''"
              maxlength="10"
            />
          </div>

          <div class="submit-btn">
            <button class="vs-primary-btn" [disabled]="showLoader">
              <em class="material-icons">search</em>
              {{ 'guesttrack.trackStatus' | cxTranslate }}
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <label class="error" *ngIf="firstMandateFieldError">{{
              'guesttrack.kindlyenter' | cxTranslate
            }}</label>
          </div>
          <div class="col-6">
            <label class="error-custom" *ngIf="secondMandateFieldError">{{
              'guesttrack.kindlyenterpurchase' | cxTranslate
            }}</label>
            <label
              class="error-custom"
              *ngIf="form['purchaseOrderNo']?.errors?.['pattern']"
              >{{ 'orderCheckOut.orderNoInvalid' | cxTranslate }}</label
            >
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="outer-container" *ngIf="!showLoader">
    <div class="status-table" *ngIf="checkCondition">
      <table class="table">
        <thead class="thead-light">
          <tr>
            <th id="orderNo">{{ 'guesttrack.order' | cxTranslate }}</th>
            <th id="orderStatus">{{ 'guesttrack.status' | cxTranslate }}</th>
            <th id="poNumber">{{ 'guesttrack.ponumber' | cxTranslate }}</th>
            <th id="poDate">{{ 'guesttrack.podate' | cxTranslate }}</th>
            <th id="orderCreated">
              {{ 'guesttrack.ordercreated' | cxTranslate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of orderData">
            <td>{{ order.code }}</td>
            <td>{{ order.orderStatus }}</td>
            <td>{{ order.purchaseOrderNumber }}</td>
            <td>{{ order.purchaseOrderDate | date : 'd MMM y' }}</td>
            <td>{{ order.placed | date : 'd MMM y' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      *ngIf="(displayDefaultPageMsg || displaySorryPageMsg) && !checkCondition"
      class="message-display-default"
    >
      <div class="error-img">&nbsp;</div>
      <div *ngIf="displayDefaultPageMsg" class="empty-text">
        {{ 'guesttrack.trackorder' | cxTranslate }}
      </div>
      <div *ngIf="displaySorryPageMsg" class="empty-text">
        {{ 'guesttrack.sorryorder' | cxTranslate }}
      </div>
    </div>
  </div>

  <!-- PAGINATION symbol to load on screen - START -->
  <div #loading class="spinner-class" *ngIf="showLoader">
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
  </div>
  <!-- PAGINATION symbol to load on screen - END -->
</div>
